import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <p>
          &copy; {currentYear} Democracy Renaissance. 
          Committed to transparency and democratic accountability.
        </p>
      </div>
    </footer>
  );
};

export default Footer;